import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=32ab4af5&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab4af5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/circleci/project/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VFooter,VSpacer})
